import React from 'react';
import Badge, { BadgeType } from '../../ui/Badge/Badge';

interface ValueListItemProps {
  label: string;
  type: BadgeType;
  value: string;
  color?: string;
}

const ValueListItem: React.FC<ValueListItemProps> = ({ label, type, value, color }) => {
  return (
    <div className="valueListItem pb-4 flex justify-between">
      {color ? (
        <span className="flex items-center gap-6 typo-text-12--bold">
          <span className="inline-block w-7 h-7 rounded-[2px] shrink-0" style={{ background: color }} />
          {label}
        </span>
      ) : (
        <Badge label={label} transparent showDot dotFilled expanded type={type} />
      )}
      <span className="value">{value}</span>
    </div>
  );
};

export default ValueListItem;
